/*
 * TBB auction end-date display (session 22)
 * --------------------------------------------------------------
 * Renders the absolute auction end date/time under the countdown
 * digits. We can't see the auction app's data attributes directly,
 * so we read the current .days / .hours / .minutes / .seconds values
 * from the DOM, add that remaining time to `now`, and format it.
 *
 * Injected element: .tbb-auction-end-date (sibling after .auction-countdown)
 * Font + muted color come from tbb-reskin.css.
 * --------------------------------------------------------------
 */
(function () {
  function readDigits(el) {
    var get = function (sel) {
      var node = el.querySelector(sel);
      if (!node) return 0;
      var n = parseInt((node.textContent || '').trim(), 10);
      return isNaN(n) ? 0 : n;
    };
    return {
      d: get('.days'),
      h: get('.hours'),
      m: get('.minutes'),
      s: get('.seconds'),
    };
  }

  function formatEnd(ms) {
    var d = new Date(ms);
    // Example: "Apr 16, 2026 • 7:42 PM PDT"
    var dateStr = d.toLocaleDateString(undefined, {
      month: 'short', day: 'numeric', year: 'numeric'
    });
    var timeStr = d.toLocaleTimeString(undefined, {
      hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
    });
    return dateStr + ' \u2022 ' + timeStr;
  }

  function render(countdownEl) {
    var parts = readDigits(countdownEl);
    var remainingMs =
      parts.d * 86400000 + parts.h * 3600000 + parts.m * 60000 + parts.s * 1000;
    if (remainingMs <= 0) return;

    var endMs = Date.now() + remainingMs;
    var existing = countdownEl.parentNode &&
      countdownEl.parentNode.querySelector(':scope > .tbb-auction-end-date');
    var node = existing || document.createElement('div');
    node.className = 'tbb-auction-end-date';
    node.textContent = 'Ends ' + formatEnd(endMs);
    if (!existing && countdownEl.parentNode) {
      countdownEl.parentNode.insertBefore(node, countdownEl.nextSibling);
    }
  }

  function init() {
    var countdowns = document.querySelectorAll('.auction-countdown');
    countdowns.forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run once after 1s in case the auction app renders async
  setTimeout(init, 1200);
})();
